import React from "react";
import { Accordion } from "react-bootstrap";
import "./Faqs.css";

function Faqs() {
  return (
    <div className="faqs">
      <div className="container mt-5 pb-5 ps-2 text-center">
        <h2>Preguntas Frecuentes</h2>
        <div className="container">
          <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                ¿Están los gastos de envío incluidos en el precio?
              </Accordion.Header>
              <Accordion.Body>
                Para compras mayores a $1.000 tendrás tu envío express gratis!
                <ul>
                  <p className="mt-2">Para montos menores tendrás la opción de:</p>{" "}
                  <li style={{ listStyle: "none" }}>envío gratis (7-9 días)</li>
                  <li style={{ listStyle: "none" }}>envío estándar por $200 (5-7 días)</li>
                  <li style={{ listStyle: "none" }}>envío express $500 (2-5 días)</li>
                </ul>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>¿Qué medios de pago aceptan?</Accordion.Header>
              <Accordion.Body>
                Aceptamos:{" "}
                <div className="d-flex gap-2 justify-content-center mt-3">
                  <img src="/img/visa.gif" className="img-fluid" alt="" />
                  <img src="/img/oca.gif" className="img-fluid" alt="" />
                  <img src="/img/creditel.png" className="img-fluid" alt="" />
                  <img src="/img/master.svg" className="img-fluid" alt="" />
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
              <Accordion.Header>¿Puedo pagar contra reembolso?</Accordion.Header>
              <Accordion.Body>
                Aún no trabajamos con esta modalidad hasta que contemos con un local físico
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4">
              <Accordion.Header>¿Es seguro comprar en TWC?</Accordion.Header>
              <Accordion.Body>
                Los pagos realizados siempre se realizan en entorno seguro, por lo tanto en TWC no
                recopilamos datos bancarios ni de números de tarjeta.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="5">
              <Accordion.Header>¿Puedo comprar botellas sueltas?</Accordion.Header>
              <Accordion.Body>
                Si, por compras mayores a 5 cajas comuníquese a hola@twc.com para descuentos
                asociados
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="6">
              <Accordion.Header>
                ¿Tienen descuentos con alguna tarjeta de crédito de algún Banco?
              </Accordion.Header>
              <Accordion.Body>No por el momento</Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="7">
              <Accordion.Header>¿Cómo puedo contactarme con TWC?</Accordion.Header>
              <Accordion.Body>
                Si necesitas más información puedes ponerte en contacto con nosotros a través del
                teléfono 099 123 456 de lunes a viernes entre las 8:00 y las 17:00 hs o a
                hola@twc.com
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>
    </div>
  );
}

export default Faqs;
